import { axiosInstance } from '@src/configs/axios.configs';
import { IResponse } from '@src/interfaces/axios.interfaces';

import { IQuizzesRequest, IQuizzesResponse } from '../types/quizzes.types';

export const quizzesService = {
  list: ({
    variant,
    ...params
  }: IQuizzesRequest): IResponse<IQuizzesResponse> =>
    axiosInstance.get(`api/quizzes/${variant}`, { params }),
};
